import { render, staticRenderFns } from "./CreatCategoryPage.vue?vue&type=template&id=214e2252&scoped=true&"
import script from "./CreatCategoryPage.vue?vue&type=script&lang=js&"
export * from "./CreatCategoryPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214e2252",
  null
  
)

export default component.exports